import http from "../http-common";

class HoldingTableDataService {
    getAll() { // get ALL the tickets currently stored in the holding table (assuming this number will never be extremely large, so no pagination)
        return http.get(`/createTicketFromEmail`);
    }

    getSpecific(id, timezoneAdjustmentFactor) {    // get just the details for the specified ticket with id passed in
        return http.get(`/createTicketFromEmail/${id}?timezoneAdjustmentFactor=${timezoneAdjustmentFactor}`);
    }

    getAttachmentPreviewLinks(id) {
        return http.get(`/createTicketFromEmail/${id}/getAttachments/previewLinks`);
    }

    getTicketHistory(id, timezoneAdjustmentFactor) {
        return http.get(`/createTicketFromEmail/${id}/history?timezoneAdjustmentFactor=${timezoneAdjustmentFactor}`);
    }

    savePrivateNote(id, creator_id, data) {  // save tech's private note to holding ticket record
        return http.post(`/createTicketFromEmail/${id}/privateNotes/${creator_id}`, data);
    }

    // this is called when user clicks red delete button (ie they aren't clarifying the ticket, just outright deleting it)
    deleteTicketOutright(id) {
        return http.delete(`/createTicketFromEmail/${id}/deleteOutright`);
    }

    // sending through the new ticket id for the hardware / software ticket that was just created before calling this endpoint
    deleteTicket(id, new_ticket_id, type_of_new_ticket) {
        return http.delete(`/createTicketFromEmail/${id}?newTicketId=${new_ticket_id}&newTicketType=${type_of_new_ticket}`);
    }

    changeIsPrivate(id, data) {  // toggle the holding ticket's is_private between 0 and 1 (called when toggle is clicked on clarify form)
        return http.put(`/createTicketFromEmail/${id}/changeIsPrivate`, data);
    }

    // sends designated ticket id and new assigned tech id to update the backend record of that ticket
    updateTechAssignment(id, data) {
        return http.put(`/createTicketFromEmail/${id}/updateTechAssignment`, data);
    }

    // updates values from clarify ticket form fields any time there's a change on the front end
    updateHoldingTicketInfo(id, data) {
        return http.put(`/createTicketFromEmail/${id}/updateHoldingTicketInfo`, data);
    }

    updateCCList(data, ticketId) {
        return http.put(`/createTicketFromEmail/${ticketId}/updateCCList`, data);
    }
}

export default new HoldingTableDataService();